export default __webpack_public_path__ + "static/media/Mark-4-Suit-01.7d78cc96.jpg";